import BuyerApi from './buyer-api';
import { tracking as barkTrackingLogEvent , isEnquiriesBuyerFeedbackModalActive} from '@bark/bark-core';
import moment from 'moment';
const page = 'seller-list';


export const handleEnquiry = (
	$button,
	trackingData,
	marketplaceInteractionCompleteCallback,
	isLastSellerToInteractOnMarketplaceList,
) => {
	const sellerId = $button.data('sellerId');
	const projectId = $('#project-id').val();
	const isMarketplace = $button.data('marketplace');

	barkTrackingLogEvent(
		'seller-list-&-profile',
		'enquiries - Call Now - Click',
		trackingData,
	);

	enquiryStartWaiting($button);
	BuyerApi()
		.createEnquiry({ projectIdHash: projectId, sellerIdHash: sellerId, isMarketplace })
		.then((response) => {
			const companyName = response?.data?.attributes?.company_name;
			const companyNumber = response?.data?.attributes?.telephone;
			const companyNumberFormatted = response?.data?.attributes?.telephone_formatted;
			const projectResponseHashId = response?.data?.id;
			window.location.assign(`tel:${companyNumberFormatted}`);
			showEnquiriesModal(
				sellerId,
				companyName,
				companyNumber,
				companyNumberFormatted,
				projectId,
				page,
				projectResponseHashId,
				marketplaceInteractionCompleteCallback,
				isLastSellerToInteractOnMarketplaceList,
			);
			enquiryStopWaiting($button);
		})
		.catch((error) => {
			enquiryHandleError($button);
			enquiryStopWaiting($button);
		});
};

export const enquiryStartWaiting = ($button) => {
	$button.find('.btn-icon-text').removeClass('d-flex').addClass('d-none');
	$button.find('.spinner-border').removeClass('d-none').addClass('d-flex');
};

export const enquiryStopWaiting = ($button) => {
	$button.find('.btn-icon-text').removeClass('d-none').addClass('d-flex');
	$button.find('.spinner-border').removeClass('d-flex').addClass('d-none');
};

export const showEnquiriesModal = (
	sellerId,
	companyName,
	companyNumber,
	companyNumberFormatted,
	projectId,
	page,
	projectResponseHashId,
	marketplaceInteractionCompleteCallback,
	isLastSellerToInteractOnMarketplaceList,
) => {
	if (window.BuyerApp) {
		window.BuyerApp.launchModule('enquiries-modal', '__enquiries-modal', {
			sellerId,
			companyName,
			companyNumber,
			companyNumberFormatted,
			projectId,
			page,
			projectResponseHashId,
			featureFlags: {
				'enquiries-buyer-feedback-modal': isEnquiriesBuyerFeedbackModalActive(),
			},
			showMessageSentConfirmation: !isLastSellerToInteractOnMarketplaceList,
			onComplete: (meta) =>
				marketplaceInteractionCompleteCallback?.('marketplace-enquiry', sellerId, meta),
		});
	}
};

export const enquiryHandleError = ($button) => {
	const sellerId = $button.data('sellerId');
	$button.prop('disabled', true);
	$(`.enquiries-feedback[data-seller-id=${sellerId}]`).removeClass('d-none');
};

export const trackEnquiries = async (projectId, sellers, pageNum, pageSize) => {
	await new Promise((resolve, reject) => {
		// pagesize is always 10, if it changes then can be passed as a parameter instead
		if (!pageSize) {
			pageSize = 10;
		}
		if (projectId && sellers.length) {
			let enquirySellers = [];
			sellers.map((seller, index) => {
				const orderPosition = (pageNum - 1) * pageSize + index + 1;
				if (seller?.attributes?.match_types.includes('enquiry')) {
					enquirySellers.push({
						seller_id: seller.id,
						list_order: orderPosition,
					});
				}
			});
			if (enquirySellers.length) {
				barkTrackingLogEvent('seller-list-&-profile', `enquiries - Active`, {
					project_id: projectId,
					seller_profile_ids: enquirySellers
						.map((enquirySeller) => enquirySeller['seller_id'])
						.join(),
					list_orders: enquirySellers
						.map((enquirySeller) => enquirySeller['list_order'])
						.join(),
					page_number: pageNum,
				});
			}
		}
		resolve();
	});
	trackMarketplaceEnquiries(projectId, sellers, pageNum, pageSize);
	trackMarketplaceTypes(projectId, sellers, pageNum, pageSize);
};

export const trackMarketplaceEnquiries = async (
	projectId,
	sellers,
	pageNum,
	pageSize,
) => {
	await new Promise((resolve, reject) => {
		// pagesize is always 10, if it changes then can be passed as a parameter instead
		if (!pageSize) {
			pageSize = 10;
		}
		if (projectId && sellers.length) {
			let enquirySellers = [];
			sellers.map((seller, index) => {
				const orderPosition = (pageNum - 1) * pageSize + index + 1;
				if (seller?.attributes?.match_types.includes('marketplace-enquiry')) {
					enquirySellers.push({
						seller_id: seller.id,
						list_order: orderPosition,
					});
				}
			});
			if (enquirySellers.length) {
				if (window.hj) {
					window.hj('event', 'marketplace_enquiry_available');
				}

				var date = moment.utc().format('YYYY-MM-DD HH:mm:ss');
				var stillUtc = moment.utc(date).toDate();

				barkTrackingLogEvent('seller-list-&-profile', 'Marketplace Enquiry - Active', {
					project_id: projectId,
					seller_profile_ids: enquirySellers
						.map((enquirySeller) => enquirySeller['seller_id'])
						.join(),
					list_orders: enquirySellers
						.map((enquirySeller) => enquirySeller['list_order'])
						.join(),
					page_number: pageNum,
					'buyer time': date,
					'utc time': moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss'),
				});
			}
		}
		resolve();
	});
};

export const trackMarketplaceTypes = async (projectId, sellers, pageNum, pageSize) => {
	await new Promise((resolve, reject) => {
		// pagesize is always 10, if it changes then can be passed as a parameter instead
		if (!pageSize) {
			pageSize = 10;
		}
		if (projectId && sellers.length) {
			let enquiryTypes = [];
			let hasMarketplaceMessage = false;
			sellers.map((seller, index) => {
				['marketplace-enquiry', 'marketplace-messages', 'marketplace-booking'].map(
					(marketplaceType) => {
						if (
							seller?.attributes?.match_types.includes(marketplaceType) &&
							enquiryTypes.indexOf(marketplaceType) === -1
						) {
							enquiryTypes.push(marketplaceType);
							if (marketplaceType === 'marketplace-messages') {
								hasMarketplaceMessage = true;
							}
						}
					},
				);
			});
			if (hasMarketplaceMessage) {
				if (window.hj) {
					window.hj('event', 'marketplace_enquiry_messages_available');
				}
			}
			if (enquiryTypes.length) {
				barkTrackingLogEvent('seller-list-&-profile', 'Marketplace Types - Active', {
					project_id: projectId,
					page_number: pageNum,
					enquiry_types: enquiryTypes.join(', '),
				});
			}
		}
		resolve();
	});
};
